module.exports = ["会使用spring-boot和SSM框架","熟悉前端（html js css）,了解js及this执行环境和作用域链以及原型链,了解Ajax","了解并会使用JQuery vue.js bootstrap elementUI前端框架","了解JavaEE（servlet jsp）和SE( Soccket BIO NIO 线程池 等)","了解全后端如何分离和单页面应用.","了解并会使用git工具","了解linux命令操作","有阅读官方文档和做学习笔记的习惯"]


//////////////////
// WEBPACK FOOTER
// ./src/components/data/dataAbility.json
// module id = oSSf
// module chunks = 1